import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {MetricTileComponent} from '../../../metric-tile/metric-tile.component';
import {MetricCard} from '../../rfi-individual-results-modal.types';
import {RfiMetricValuePipe} from '../../rfi-metric-value.pipe';

@Component({
  selector: 'app-rfi-metric-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, RfiMetricValuePipe, MetricTileComponent],
  templateUrl: './rfi-metric-grid.component.html',
})
export class RfiMetricGridComponent {
  readonly cards = input.required<MetricCard[]>();
}
